module.exports = __webpack_public_path__ + "img/imagem-indisponivel-2.116bb50f.png";